import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import AboutPage from './pages/AboutPage';
import FounderPage from './pages/FounderPage';
import ProgramsPage from './pages/ProgramsPage';
import FutureHubPage from './pages/FutureHubPage';
import MediaPage from './pages/MediaPage';
import GalleryPage from './pages/GalleryPage';
import VisitPage from './pages/VisitPage';
import AccessibilityControls from './components/AccessibilityControls';
export function App() {
  const [fontSize, setFontSize] = useState('normal');
  const [highContrast, setHighContrast] = useState(false);
  return <BrowserRouter data-id="element-0">
      <div className={`font-${fontSize} ${highContrast ? 'high-contrast' : ''} min-h-screen flex flex-col`} data-id="element-1">
        <AccessibilityControls fontSize={fontSize} setFontSize={setFontSize} highContrast={highContrast} setHighContrast={setHighContrast} data-id="element-2" />
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/menu" element={<MenuPage data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
            <Route path="/founder" element={<FounderPage data-id="element-13" />} data-id="element-12" />
            <Route path="/programs" element={<ProgramsPage data-id="element-15" />} data-id="element-14" />
            <Route path="/future-hub" element={<FutureHubPage data-id="element-17" />} data-id="element-16" />
            <Route path="/media" element={<MediaPage data-id="element-19" />} data-id="element-18" />
            <Route path="/gallery" element={<GalleryPage data-id="element-21" />} data-id="element-20" />
            <Route path="/visit" element={<VisitPage data-id="element-23" />} data-id="element-22" />
          </Routes>
        </main>
        <Footer data-id="element-24" />
      </div>
    </BrowserRouter>;
}